import React, { useEffect, createElement } from 'react';
export const FacebookPixel = () => {
  useEffect(() => {
    // Defer pixel loading until after page is interactive
    const loadPixel = () => {
      const script = document.createElement('script');
      script.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window,document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '971096055471149');
        fbq('track', 'PageView');
      `;
      document.head.appendChild(script);
    };
    // Load pixel after 2 seconds to not block initial render
    const timer = setTimeout(loadPixel, 2000);
    return () => clearTimeout(timer);
  }, []);
  return null;
};